module.exports = __webpack_public_path__ + "static/ios-d953330d427e2c6d423e6644bf1e6a41.png";